import { userInfoHandler, userProfileHandler, userUploadImageHandler, changePhoneHandler, getMyCardQRCode } from '@api/user-api'
import authAPI from '@api/auth-api'
import router from '../../router'
import store from '@/store/index'
import { Message, MessageBox } from 'element-ui'
import UserStorage from '../storage/user.storage';
import TokenStorage from '../storage/token.storage';
import i18n from '@/helper/i18n'

const user = {
    namespaced: true,
    state: {
        userToken: TokenStorage.token? TokenStorage.token:  null,
        userInfo: UserStorage.userInfo,
        userFeedback: null,
        userInactive: false,
        lineFriendToken: UserStorage.userLineFriendToken || null
    },
    getters: {
        userToken(state) {
            if(state.userToken)
                return state.userToken;
            return TokenStorage.token
        },
        userInfo(state) {
            return state.userInfo;
        },
        userFeedback(state) {
            return state.userFeedback;
        },
        userInactive(state) {
            return state.userInactive;
        },
        lineFriendToken(state){
            return state.lineFriendToken
        }
    },
    mutations: {
        SET_USER_TOKEN(state, token) {
            state.userToken = token;
            TokenStorage.token = token;
        },
        SET_USER_INFO(state, payload) {
            state.userInfo = payload;
            UserStorage.userInfo = payload;
        },
        SET_POINT(state, point) {
            state.userInfo.point = point;
            UserStorage.userInfo.point = {
                ...UserStorage.userInfo,
                point,
            };
        },
        SET_USER_FEEDBACK(state, userFeedback) {
            state.userFeedback = userFeedback;
        },
        SET_USER_INACTIVE(state, payload) {
            state.userInactive = payload;
        },
        SET_LINE_FRIEND_TOKEN(state, data){
            state.lineFriendToken = data;
            UserStorage.userLineFriendToken = data;
        },
        CLEAR_LINE_FRIEND_TOKEN(state) {
            state.userLineToken = null;
            UserStorage.clearLineFriendToken()
        },
    },
    actions: {
        async fetchUserInfo({ commit, dispatch }) {
            return await userInfoHandler({
                restaurantUUID: store.getters['restaurant/restaurantUUID'],
                branchUUID: store.getters['branch/branchUUID'],
            })
                .then(async (response) => {
                    if(response.data.data){
                        await commit('SET_USER_INFO', response.data.data);
                        await commit('SET_USER_FEEDBACK',  response.data.data.feedback || null )
                        return response.data.data;
                    }
                    throw { response: { 
                                status: 404 
                            }
                        }
                })
                .catch(async (error) => {
                    if (error.response) {
                        if(error.response.status === 401){
                            await MessageBox.alert(
                                `${i18n.t('login.session-expired')}
                                <br>${i18n.t('login.login-again')}`,
                                i18n.t('store.mistake'),
                                { dangerouslyUseHTMLString: true, center: true },
                            )
                        }else if(error.response.status === 404){
                            dispatch("clearUserData");
                            await store.dispatch('auth/doLogout');
                            router.push({ name: "Login" });
                        } else {
                            await MessageBox.alert(
                                `${i18n.t('store.error-user')}
                                <br>${i18n.t('store.try-again-later')}`,
                                i18n.t('store.mistake'),
                                { dangerouslyUseHTMLString: true, center: true },
                            )
                        }
                        dispatch("clearUserData");
                        await store.dispatch('auth/doLogout');
                        router.push({ name: "Login" });
                    }
                    return false;
                });
        },
        async setProfileData({ state, commit }, payload) {
            return await userProfileHandler(payload)
                .then((response) => {
                    const { email, name, gender, birthdate, policyFlag, point } = response.data;
                    const { userInfo } = state
                    userInfo.email = email
                    userInfo.name = name
                    userInfo.gender = gender
                    userInfo.birthdate = birthdate
                    userInfo.policyFlag = !!policyFlag
                    userInfo.point = point
                    
                    commit("SET_USER_INFO", userInfo);
                    Message.success(i18n.t('store.successfully')+' !');
                })
                .catch((error) => {
                    Message.error({ duration: 2000, message: i18n.t('store.auth.error-occurred')+' !' });
                });
        },
        async changePhoneHandler({ state, commit }, payload){
            return await changePhoneHandler(payload)
            .then((response) => {
                const token = `${response.data.tokenType} ${response.data.accessToken}`
                const { userInfo } = state
                userInfo.phoneNumber = payload.phoneNumber
                commit("SET_USER_INFO", userInfo);
                commit('SET_USER_TOKEN', token);
                return true
            })
            .catch(error => {
                let message = i18n.t('store.auth.error-occurred')+' !' 
                if(error && error.response){
                    switch (error.response.status) {
                        case 401: message = i18n.t('store.auth.invalid-otp')+' !'
                            break;
                        case 404: message = i18n.t('store.auth.not-found-member')+' !'
                            break;
                        case 409: message = i18n.t('register.duplicate-phone-number')+' !'
                            break;
                    }
                   
                    Message.error({
                        message,
                        duration: 2000,
                    })
                    throw message
                }
                throw { errorSystem: true }
            });
        },
        async sendVerifyHandler({ commit }, payload){
            return await authAPI.sentVerifyPhoneCRMHandler(payload)
            .then((response) => {
                return response.data
            })
            .catch(error => {
                let message = i18n.t('store.auth.error-occurred')+' !' 
                if(error && error.response){
                    if(error.response.status === 400){
                        message = i18n.t('store.auth.invalid-phone')+' !'
                    }else if(error.response.status === 429){
                        message = i18n.t('store.auth.otp-too-often')+' !'
                    }
                }
                Message.error({
                    message,
                    duration: 2000,
                })
                throw message
            });
        },
        async setUserImage({ commit }, payload) {
            const { restaurantUUID } = store.getters['restaurant/restaurantInfo']
            return await userUploadImageHandler({
                image: payload,
                restaurantUUID: restaurantUUID,
            })
                .then((response) => {
                    commit('SET_USER_INFO', response.data);
                    Message.success({ duration: 1000, message: i18n.t('store.successfully')+' !' });
                    return response;
                })
                .catch(() => {
                    Message.error({ duration: 2000, message: i18n.t('store.auth.error-occurred')+' !' });
                });
        },
        async setUserInactive({ commit }, payload) {
            commit("SET_USER_INACTIVE", payload);
        },
        clearUserData({ commit }) {
            commit("SET_USER_INFO", null);
            commit("SET_USER_TOKEN", null);
            commit("SET_USER_INACTIVE", false);
            UserStorage.clear();
            TokenStorage.clear();
        },
        async getMyCardQRCode({ state, commit, dispatch }, payload){
            return await getMyCardQRCode(payload)
            .then((response) => {
                if(response.status == 201) {
                    return response.data;
                }
            })
            .catch(async error => {
                if (error.response) {
                    await MessageBox.alert(
                        `${i18n.t('store.error-user')}
                        <br>${i18n.t('store.try-again-later')}
                        <br>${error.message}`,
                        i18n.t('store.mistake'),
                        { dangerouslyUseHTMLString: true, center: true },
                    )
                    dispatch("clearUserData");
                    await store.dispatch('auth/doLogout');
                    router.push({ name: "Login" });
                }
                return false;
            });
        },
    }
}

export default user
